module.exports = __webpack_public_path__ + "img/logo-capstone@2x.21fcd7e7.png";